import Utils from '../Services/Utils';
import SelectOptions from '../Services/SelectOptions';

class FieldConditionRule {
  constructor(item={}) {
    this.conditionField = item.conditionField || null;
    this.ruleValue = !Utils.isNull(item.ruleValue) ? item.ruleValue : null;
    this.conditionValue = !Utils.isNull(item.conditionValue) ? item.conditionValue : null;
    this.errors = {};
  }

  static parse(field, item, fieldsIdLabelDict, fieldsIdOptionsDict) {
    const conditionFieldValue = item.condition_field || item.conditionField;
    const conditionField = !Utils.isNull(conditionFieldValue) ? (conditionFieldValue.value || conditionFieldValue) : null;
    const conditionValueValue = item.condition_value || item.conditionValue;
    let conditionValue = !Utils.isNull(conditionValueValue) ? (conditionValueValue.value || conditionValueValue) : null;
    if (Array.isArray(conditionValue)) {
      conditionValue = conditionValue.map(item => !Utils.isNull(item.value) ? item.value : item);
    }
    const ruleValueValue = item.rule_value || item.ruleValue;
    let ruleValue = !Utils.isNull(ruleValueValue) ? (ruleValueValue.value || ruleValueValue) : null;
    if (Array.isArray(ruleValue)) {
      ruleValue = ruleValue.map(item => !Utils.isNull(item.value) ? item.value : item);
    }
    const conditionOptions = fieldsIdOptionsDict ? fieldsIdOptionsDict[conditionField] : [];
    const condition = (conditionOptions && conditionOptions.length > 0) ? SelectOptions.getValue(conditionOptions, conditionValue) : conditionValue;
    const rule = (field.options && field.options.length > 0) ? SelectOptions.getIndexValue(field.options, ruleValue) : ruleValue;
    return new FieldConditionRule({
      conditionField: conditionField ? this._parseConditionField(conditionField, fieldsIdLabelDict) : null,
      ruleValue: !Utils.isNull(rule) ? rule : null,
      conditionValue: !Utils.isNull(condition) ? condition : null,
    });
  }

  serialize() {
    let conditionValue = null;
    if (!Utils.isNull(this.conditionValue) && Array.isArray(this.conditionValue)) {
      conditionValue = this.conditionValue.map(item => item.value);
    }
    else {
      conditionValue = (Utils.isObject(this.conditionValue) ? this.conditionValue.value : this.conditionValue);
    }
    let ruleValue = null;
    if (!Utils.isNull(this.ruleValue) && Array.isArray(this.ruleValue)) {
      ruleValue = this.ruleValue.map(item => item.value);
    }
    else {
      ruleValue = Utils.isObject(this.ruleValue) ? this.ruleValue.value : this.ruleValue;
    }
    return {
      condition_field: this.conditionField.value,
      rule_value: ruleValue,
      condition_value: conditionValue
    };
  }

  static _parseConditionField(val, fieldsIdLabelDict) {
    const value = Utils.isObject(val) ? val.value : val;
    return {
      label: fieldsIdLabelDict[value],
      value: value,
    };
  }
}

export default FieldConditionRule;